import { useMemo } from 'react';
import DonutChart from '..';
import { element, useElementProps } from '../../../core/elements';
import { scaleOrdinal } from '../../../primitives/scale';
import { DEFAULT_ORDINAL_PATTERNS } from '../../../primitives/theme';
export const DonutScalesElement = element(_ref => {
  let {
    data,
    colorAccessor,
    valueAccessor,
    sort,
    children
  } = _ref;
  const {
    fillStyles,
    enableDefaultPatterns,
    useThemeFillStyles
  } = useElementProps(DonutChart.elements.Theme);
  const value = useMemo(() => {
    const sortedData = sort === 'none' ? data : [...data].sort((a, b) => {
      const valueA = valueAccessor(a);
      const valueB = valueAccessor(b);
      if (valueA === valueB) return 0;
      const comparison = valueA > valueB ? 1 : -1;
      return sort === 'desc' ? -comparison : comparison;
    });
    const {
      domain,
      range
    } = useThemeFillStyles({
      fillStyles: enableDefaultPatterns ? DEFAULT_ORDINAL_PATTERNS : fillStyles
    });
    const colorScale = scaleOrdinal({
      domain: domain ? domain : sortedData.map(colorAccessor),
      range: range
    });
    return {
      colorScale,
      data: sortedData
    };
  }, [data, colorAccessor, valueAccessor, fillStyles, enableDefaultPatterns]);
  return children(value);
});